import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acedbcb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "This is still a work a progress, not every microgesture can be read using the 3D hand", -1))

import ThreeDHand from '@/components/Reader/3DHand'
import MicrogestureInput from '@/components/Microgesture/MicrogestureInput'
import Button from '@/components/UI/ButtonComponent.vue'
import { onMounted, ref } from 'vue'


export default {
  __name: 'ReaderView',
  setup(__props) {

const read = ref(0)
const glyph = ref([])
const microgesture = ref(undefined)
const reload = ref(0)

const copiedMicrogesture = ref(undefined)

function microgestureToGlyph (m) {
  if (m.type === 'in-construction') {
    return ''
  }
  if (m.type === 'glyph') {
    let finger1, finger2
    if (m.actuator.length === 0) {
      finger1 = 'index'
    } else {
      finger1 = m.actuator[0].join('-')
    }
    if (m.contact && m.contact.actuator && m.contact.actuator.length > 0) {
      finger2 = m.contact.actuator[0].join('-')
    } else {
      finger2 = 'thumb'
    }
    if (m.action === 'Any') {
      if (m.context[0] === 'Air' && m.context[1] === 'Contact') {
        return [`${finger1}-${finger2}-Flexion-${m.context[0]}-${m.context[1]}`.toLowerCase()]
      }
      if (m.context[0] === 'Contact' && m.context[1] === 'Air') {
        return [`${finger1}-${finger2}-Extension-${m.context[0]}-${m.context[1]}`.toLowerCase()]
      }
    }
    return [`${finger1}-${finger2}-${m.action}-${m.context[0]}-${m.context[1]}`.toLowerCase()]
  } else if (m.type === 'then') {
    const temp = []
    for (const x of m.operands) {
      temp.push(...microgestureToGlyph(x))
    }
    return temp
  } else if (['and', 'or'].includes(m.type)) {
    throw Error('not implemented')
  } else if (m.type === 'seq') {
    throw Error('not implemented')
  }
}

function updateMicrogesture (newMicrogesture) {
  microgesture.value = newMicrogesture
}

function readMicrogesture () {
  glyph.value = microgestureToGlyph(microgesture.value)
  read.value++
}

onMounted(() => {
  if (copiedMicrogesture.value) {
    microgesture.value = copiedMicrogesture.value
    copiedMicrogesture.value = undefined
    reload.value++
    glyph.value = microgestureToGlyph(microgesture.value)
  }
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", { key: reload.value }, [
    _hoisted_1,
    _createVNode(_unref(MicrogestureInput), {
      "model-value": microgesture.value,
      "onUpdate:modelValue": updateMicrogesture,
      "allow-edit-button": false,
      "auto-paste": true
    }, null, 8, ["model-value"]),
    _createVNode(Button, { onClick: readMicrogesture }, {
      default: _withCtx(() => [
        _createTextVNode("Read")
      ]),
      _: 1
    }),
    _createVNode(_unref(ThreeDHand), {
      glyph: glyph.value,
      read: read.value
    }, null, 8, ["glyph", "read"]),
    false
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => (glyph.value = ['index-thumb-flexion-air-contact', 'index-thumb-extension-contact-air']))
          }, "Tap Index"),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = $event => (glyph.value = ['middle-thumb-flexion-air-contact', 'middle-thumb-extension-contact-air']))
          }, "Tap Middle"),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = $event => (glyph.value = ['index-thumb-flexion-air-contact', 'index-thumb-flexion-contact-contact', 'index-thumb-flexion-contact-air']))
          }, "Swipe Inward")
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

}